/** Structured recoverable director errors — never surface raw provider failures to UI. */

export const DIRECTOR_OUTPUT_SCHEMA_VERSION = '2.0.0' as const;

export type RecoverableAction = 'retry' | 'fallback' | 'user_choice' | 'save_draft';

export type DirectorFailureKind =
  | 'invalid_json'
  | 'missing_required'
  | 'unknown_fields'
  | 'oversized'
  | 'schema_mismatch'
  | 'transport_error'
  | 'version_mismatch';

export interface StructuredDirectorError {
  kind: DirectorFailureKind;
  message: string;
  actions: RecoverableAction[];
  schemaId?: string;
  details: string[];
}

const DEFAULT_ACTIONS: Record<DirectorFailureKind, RecoverableAction[]> = {
  invalid_json: ['retry', 'fallback'],
  missing_required: ['retry', 'fallback'],
  unknown_fields: ['retry', 'fallback'],
  oversized: ['fallback', 'user_choice'],
  schema_mismatch: ['retry', 'fallback'],
  transport_error: ['retry', 'fallback'],
  version_mismatch: ['fallback', 'user_choice'],
};

export function directorError(
  kind: DirectorFailureKind,
  message: string,
  opts?: { schemaId?: string; details?: string[]; actions?: RecoverableAction[] },
): StructuredDirectorError {
  return {
    kind,
    message,
    actions: opts?.actions ?? DEFAULT_ACTIONS[kind],
    schemaId: opts?.schemaId,
    details: opts?.details ?? [],
  };
}

/** UI-safe summary — no raw provider payloads or stack traces. */
export function formatDirectorErrorForUi(error: StructuredDirectorError): string {
  return error.message;
}
